import React from 'react'
import { Link } from 'react-router-dom'
import { Version } from '../..'
import { useSettings } from '../../Hook/Home'
import Layout from '../../Layout'
import HeaderMain from '../../Components/HeaderMain'
function Index() {
    const { state, changeAlertChat } = useSettings();
    return (
        <Layout>
            <HeaderMain lable="تنظیمات" />
            <div className="all-rule">
                <Link to={'/EditProfile'}>
                    <div className=" mt-3 all-content">
                        <div className="account py-3 pb-2"><p>حساب کاربری</p></div>
                        <div className=" d-flex justify-content-between px-3 py-3">
                            <div className="content">
                                <i className="fas fa-user me-5"></i>
                                <span >ویرایش حساب کاربری</span>
                            </div>
                            <div className="i-angle px-3"> <i className="far fa-angle-left"></i></div>
                        </div>
                    </div>
                </Link>
                <div className="all-content">
                    <div className="account py-3 pb-2 mt-3"><p>اعلانات</p></div>
                    <div className=" d-flex justify-content-between px-3 py-3">
                        <div className="content">
                            <i className="fas fa-comments-alt me-5"></i>
                            <span >دریافت اعلان های چت</span>
                        </div>
                        <div className="form-check form-switch">
                            <input className="form-check-input" checked={state.alertChat ? true : false} onChange={changeAlertChat} type="checkbox" role="switch" id="flexSwitchCheckChecked" />
                        </div>
                    </div>
                </div>

                <div className=" all-content">
                    <div className="account py-3"><p>اطلاعات حقوقی واشتراک گذاری</p></div>
                    <div className=" px-3 py-2">
                        <Link to={'/Rule'}>
                            <div className="content mb-4 d-flex justify-content-between ">
                                <div> <i className="fas fa-info-circle me-5"></i>
                                    <span >قوانین و دستورالعمل ها</span>
                                </div>
                            </div>
                        </Link>
                        {/* <div className="d-flex mb-4">
                            <i className="fas fa-star me-5"></i>
                            <span>امتیاز دهی ب شیپور</span>
                        </div> */}
                        {/* <div className="d-flex justify-content-between mb-2">
                            <div>
                                <i className="fas fa-share-alt me-5"></i>
                                <span>اشتراک گذاری شیپور با دیگران</span>
                            </div>
                        </div> */}
                    </div>
                </div>
                <div className="version-pic d-flex justify-content-center">
                    <span> app version {Version}</span>
                </div>
            </div>

        </Layout>
    )
}

export default Index